import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { useApiMutation } from '../useApiMutation';
import { apiPost, operationsClient } from '@/lib/api';
import { taskEndpoints } from '@/lib/api/endpoints';
import { taskKeys } from '@/lib/queryKeys';
import { myDayQueryKey } from '@/hooks/tracking/useMyDay';

/**
 * Move a task you are assigned between to do / in progress / done — the
 * route technicians use, since they hold contacts:view but not contacts:edit.
 */
export function useAssigneeTaskStatus() {
  const queryClient = useQueryClient();
  return useApiMutation<unknown, { taskId: string; status: 'todo' | 'in_progress' | 'done' }>({
    mutationFn: ({ taskId, status }) =>
      apiPost(operationsClient, taskEndpoints.assigneeStatus(taskId), { status }),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: taskKeys.all() });
      void queryClient.invalidateQueries({ queryKey: myDayQueryKey });
      toast.success('Task updated');
    },
  });
}
